import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SubstitutionBoardEnumerations } from 'src/app/interfaces/interfaces.module';
import { ProposalListItemModel } from '../../models/proposal-list-item-model';

@Component({
    selector: 'app-proposal-list-item',
    templateUrl: './proposal-list-item.component.html',
    styleUrls: ['./proposal-list-item.component.scss'],
    standalone: false
})
export class ProposalListItemComponent implements OnInit {
    @Input() public model: ProposalListItemModel;
    @Input() public clubId: string;
    @Output() public proposalApproved = new EventEmitter<ProposalListItemModel>();
    @Output() public proposalRejected = new EventEmitter<ProposalListItemModel>();

    constructor() {}

    ngOnInit() {}

    public getPhotoUrl(url: string) {
        if (!url) {
            return null;
        }

        return url + '?format=raw&&height=50';
    }

    public get shouldShowActions(): boolean {
        return this.model.status.code === SubstitutionBoardEnumerations.SubstitutionProposalStatus.pending.code;
    }

    public get cancelledByProvider(): boolean {
        return this.model.status.code === SubstitutionBoardEnumerations.SubstitutionProposalStatus.cancelledByProvider.code;
    }

    public get rejectedByManager(): boolean {
        return this.model.status.code === SubstitutionBoardEnumerations.SubstitutionProposalStatus.rejectedByManager.code;
    }

    public get approved(): boolean {
        return this.model.status.code === SubstitutionBoardEnumerations.SubstitutionProposalStatus.approved.code;
    }

    public get cancelledByRequest(): boolean {
        return this.model.status.code === SubstitutionBoardEnumerations.SubstitutionProposalStatus.cancelledByRequest.code;
    }

    public onReject() {
        this.proposalRejected.emit(this.model);
    }

    public onApprove() {
        this.proposalApproved.emit(this.model);
    }

    public get proposalIsInactive() {
        return !(
            this.model.status.code === SubstitutionBoardEnumerations.SubstitutionProposalStatus.approved.code ||
            this.model.status.code === SubstitutionBoardEnumerations.SubstitutionProposalStatus.pending.code
        );
    }
}
